import React from 'react';
import { Container, Box, useColorModeValue } from '@chakra-ui/react';
import TokenCreationForm from '../components/TokenCreationForm';
import ConnectWallet from '../components/ConnectWallet';
import { useWeb3 } from '../lib/Web3Provider';

const CreatePage: React.FC = () => {
  const { connected } = useWeb3();
  const bgColor = useColorModeValue("white", "gray.800");

  if (!connected) {
    return <ConnectWallet />;
  }

  return (
    <Container maxW="container.lg" py={8}>
      <Box 
        bg={bgColor}
        p={8} 
        borderRadius="lg" 
        boxShadow="md"
      >
        <TokenCreationForm />
      </Box>
    </Container>
  );
};

export default CreatePage;